<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ResetPassword from '../../../auth/components/ResetPassword.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <ResetPassword />
</template>